import type { ApiRequestFn } from "../../types/api";
import type { BankProviderEntry, CreateBankRequest, UpdateBankRequest } from "../../types/settings";

const createBanksApi = (request: ApiRequestFn) => ({
  list: () => request<BankProviderEntry[]>("/me/banks"),

  create: (data: CreateBankRequest) => request<{ success: boolean }>("/me/banks", { method: "POST", body: JSON.stringify(data) }),

  update: (id: number, data: UpdateBankRequest) => request<{ success: boolean }>(`/me/banks/${id}`, { method: "PUT", body: JSON.stringify(data) }),

  setDefault: (id: number) => request<{ success: boolean }>(`/me/banks/${id}/default`, { method: "PATCH" }),

  remove: (id: number) => request<void>(`/me/banks/${id}`, { method: "DELETE" }),
});

export { createBanksApi };
